import * as React from 'react';

// oxlint-disable-next-line typescript/no-explicit-any
export function getDisplayName(Component: React.ComponentType<any>): string {
  return Component.displayName || Component.name || 'Component';
}
